import { render, staticRenderFns } from "./Evidence.vue?vue&type=template&id=21c7d932&scoped=true&"
import script from "./Evidence.vue?vue&type=script&lang=js&"
export * from "./Evidence.vue?vue&type=script&lang=js&"
import style0 from "./Evidence.vue?vue&type=style&index=0&id=21c7d932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7d932",
  null
  
)

export default component.exports